import { InputContainer } from "@/components/ui/forms/inputContainer"
import { Switch } from "@/components/ui/baseUi/switch"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { type FieldValueChange } from "@/typings/formik"
import { type FieldInputProps } from "formik"

type SwitchInlineInputProps<T, K> = {
  label?: string
  name: string
  isRequiredInput?: boolean
  setFieldValue: FieldValueChange<K>
  getFieldProps: (nameOrOptions: T) => FieldInputProps<any>
  error?: React.JSX.Element
  className?: string
  containerClassName?: string
  switchContainerClassName?: string
  textSwitch?: string
  disabled?: boolean
  switchProps?: React.ComponentProps<typeof Switch>
  children?: React.ReactNode
} & React.ComponentProps<"div">

export function SwitchInlineInput<T, K>({
  label,
  name,
  isRequiredInput = false,
  setFieldValue,
  getFieldProps,
  error,
  className,
  containerClassName,
  switchContainerClassName,
  textSwitch,
  disabled = false,
  switchProps,
  children,
  ...props
}: SwitchInlineInputProps<T, K>) {
  const value = getFieldProps(name as T).value || false

  return (
    <InputContainer
      label={label}
      name={name}
      isRequiredInput={isRequiredInput}
      error={error}
      className={className}
      {...props}
    >
      <div className={cn("inline-flex flex-col gap-2", containerClassName)}>
        <div
          className={cn(
            "flex w-full flex-row items-center justify-between rounded-2xl bg-surface-foreground px-5 py-3.5 transition-all",
            switchContainerClassName,
          )}
        >
          <Text fontStyle="LL" className="text-foreground">
            {textSwitch}
          </Text>
          <Switch
            checked={value === true}
            disabled={disabled}
            onCheckedChange={() => {
              setFieldValue(name, !value)
            }}
            {...switchProps}
          />
        </div>
        {children}
      </div>
    </InputContainer>
  )
}
